import React from "react";
import "./Launch.css";
import { useNavigate } from "react-router-dom";

export default function Launch() {
  const navigate = useNavigate();
  return (
    <div id="product-launch">
      <div className="overlay"></div>
      <div className="content productmainclass">
        <h2 className="heading">Your Product Deserves the Right Team</h2>
        <p className="subheading">
         Choose a product development company focused on real outcomes, faster launches, and building reliable products that support long-term business growth.
        </p>
        <button onClick={()=> navigate('/contact_us')}> Book a Free Consultation</button>
      </div>
    </div>
  );
}
